// Node
const $ = require('jquery');


$(function () {
    $('body').keypress(function (e) {
        let letter = String.fromCharCode(e.charCode ? event.charCode : event.which);
        if (letter == "!") { // Нажать shift + 1 чтобы скопировать куки в буфер обмена
            copyCookieToClipboard();
            console.log('Cookie успешно скопированы');
        } else if (letter == "%") { // Нажать shift + 5 чтобы вставить куки из буфера обмена
            pasteCookieFromClipboard();
            console.log('Cookie успешно обновлены, перезагрузите страницу или перейдите на любую другую');
        }
    });

    function getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) {
            return parts.pop().split(';').shift();
        }
    }

    function copyCookieToClipboard() {
        navigator.clipboard.writeText(getCookie('_mt_session'));
    }

    function pasteCookieFromClipboard() {
        navigator.clipboard.readText()
            .then(text => {
                document.cookie = `_mt_session = ${text}`
            })
            .catch(() => {
                console.log('Failed to read from clipboard.');
            });
    }
});
